import React, { useEffect } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { SuccessAddsWeight } from './components/SuccessAddsWeight';
import { WhoThisIsFor } from './components/WhoThisIsFor';
import { WhoThisIsNotFor } from './components/WhoThisIsNotFor';
import { Solution } from './components/Solution';
import { FoundationCheck } from './components/FoundationCheck';
import { Outcome } from './components/Outcome';
import { Credibility } from './components/Credibility';
import { Pathway } from './components/Pathway';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { FinalCta } from './components/FinalCta';
import { StickyCta } from './components/StickyCta';
export function App() {
  useEffect(() => {
    document.title = 'Unified Success Masterclass';
  }, []);
  return <div className="min-h-screen w-full bg-ink font-sans text-white antialiased" data-id="element-0" data-mp="23vcm2yxfpmes">
      <AnnouncementBar data-id="element-1" data-mp="23ti864kkyuk7" />
      <main data-id="element-2" data-mp="3ik7k0rkruvvx">
        <Hero data-id="element-3" data-mp="3ikr0e3urxc7u" />
        <SuccessAddsWeight data-id="element-4" data-mp="3ij652c0mxp8x" />
        <WhoThisIsFor data-id="element-5" data-mp="3ihv1odb3qjic" />
        <WhoThisIsNotFor data-id="element-6" data-mp="3mlj82snzz920" />
        <Solution data-id="element-7" data-mp="3mkrefndynled" />
        <FoundationCheck data-id="element-8" data-mp="3mk852v2dm5by" />
        <Outcome data-id="element-9" data-mp="3mjgannkimdn9" />
        <Credibility data-id="element-10" data-mp="3rc9du70c5dx8" />
        <Pathway data-id="element-11" data-mp="3rbrbqtqzs5he" />
        <Urgency data-id="element-12" data-mp="3rdar8i4tqci4" />
        <Pricing data-id="element-13" data-mp="3rcswxr1q28cu" />
        <FinalCta data-id="element-14" data-mp="3reccfffk0fdk" />
      </main>
      <StickyCta data-id="element-15" data-mp="5opww5kum4f" />
    </div>;
}